import React, { useCallback, useEffect, useRef, useState } from "react";
import "./Reports.css";
import ReportsTile from "../reportsTile/ReportsTile";
import { Box, Button, Grid, IconButton, Link, TextField, Typography } from "@mui/material";
import { downloadReportAttributes, downloadReportRequestBody, reportListObject } from "../types/types";
import { downloadReport, downloadReportOfID, getMetadataForReport, task } from "../../../services/reportService";
import { useDispatch,useSelector } from "react-redux";
import { getMetaDataConfig, getUserRolesBasedOnAccess, isRoleConfigEnabled } from "../../../services/uiConfigService";
import { Role } from "../../../components/userModal/userModalType";
import DownloadLoader from "../../../components/popup/downloadLoader";
import { eventEnum, logEvent } from "../../../services/eventsService/eventService";
import { getAllConfiguartions } from "../../../services/updateMetaConfigService";
import { findReportsElement, getReportConfig } from "../../../services/mdmService/mdmService";
import { openPopup } from "../../../stateManagement/actions/popupActions";
import { TranslationEnum, usePortalTranslation } from "../../../providers/TranslationProvider";
import { ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPut } from "../../../services/networkService";
import InfoIcon from "@mui/icons-material/Info";
import { Modal, TextInput } from "@mantine/core";
import store from "../../../stateManagement/store";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import DownloadBar from "../../../components/popup/downloadBar";
import DownloadBarIcon from "../../../components/popup/downloadBarIcon";
import ToogleButton from "../../../components/ToogleButton/ToogleButton";
import { getLob, sendForgotPasswordOtpAddress, verifyOtpFromServer } from "../../../services/authenticationService";
import { maskEmail } from "../../otpVerification/otpVerificationUtils";
import ReportOtp from "./ReprotOtp";


const Reports = () => {
  const {translate} = usePortalTranslation();
  const CUR_COMPONENT = "Reports"
  const [reportList, setReportList] = useState<reportListObject[]>([]);
  const [reportLoader,setReportLoader] = useState<boolean>(false);
  const [needPassword, setNeedPassword] = useState<boolean>(false);
  const [hasPassword, setHasPassword] = useState<boolean>(false);
  const [changePasswordModal, setChangePasswordModal] = useState<boolean>(false);
  const [passwordQuery, setPasswordQuery] = useState<boolean>(false);
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [showPasswordModal, setShowPasswordModal] = useState<boolean>(false);
  const [setPassFlow, setSetPassFlow] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [headerOtp, setHeaderOtp] = useState("");
  const [sessionID, setSessionID] = useState("");
  const [sessionIDVerify, setSessionIDVerify] = useState("");
  const downloadCount = useSelector((state:any) => state.downloadBarReducer.downloadCount);
  const downloads = useSelector((state:any) => state.downloadBarReducer.downloads);
  const showDownload = useSelector((state:any) => state.downloadBarReducer.showDownload);
  const [passwordConfig,setPasswordConfig]=useState<boolean>(false);
 
 useEffect(() => {
  const handleBeforeUnload = (event: BeforeUnloadEvent) => {
    const shouldWarn = downloadCount; 
   
    if (shouldWarn) {
      event.preventDefault();      
      event.returnValue = '';     
    }
  };
  
  window.addEventListener('beforeunload', handleBeforeUnload);
  return () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  };
}, [downloadCount]);

  const validatePassword = (password: string) => ({
    length: password.length >= 8 && password.length <= 20,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    symbol: /[@$!%*?&]/.test(password),
  });

  const validations = validatePassword(password);
  const allValid = Object.values(validations).every(Boolean);
  const passwordsMatch = password === confirmPassword;
  const setReportPassword = async () => {
    try {
      const networkService = store
        .getState()
        .serviceRegistry.get("ChannelkartNetwork");
      const encryptedPassword = await networkService.encrypt(
        password
      );
      const headers:any={
        // otp:headerOtp,
        sessionID:sessionIDVerify
      }
      const requestBody: any = { reportPassword: encryptedPassword };
      const response = await ChannelkartNetworkPut(
        "/users/reportpassword",
        requestBody,
        headers
      );
      if (response?.status === 200) {
        setNeedPassword(false);
        setPasswordQuery(false)
        setPassword("");
        setConfirmPassword("");
        openPopup(
          "Success",
          "Your password has been created successfully. You can now securely access your reports"
        );
        window.location.reload();
      } else {
        console.error("Failed to set the report password. Response:", response);
        setPassword("");
        setConfirmPassword("");
      }
    } catch (error) {
      setPassword("");
      setConfirmPassword("");
      console.error(
        "An error occurred while setting the report password:",
        error
      );
    }
  };
  const [contactAddressType, setcontactAddressType] = useState("email");
  const [isverifiedOtp, setisverifiedOtp] = useState(false);
  const [otpLength, setOtpLength] = useState(6);
  const [validateUserModal, setValidateUserModal] = useState<boolean>(false);
  const [verifyOTPModal, setVerifyOTPModal] = useState<boolean>(false);
  const changeReportPassword = async () => {
    try {
      const headers:any={
        // otp:headerOtp,
        sessionID:sessionIDVerify
      }
      const networkService = store
        .getState()
        .serviceRegistry.get("ChannelkartNetwork");
      const encryptedPassword = await networkService.encrypt(
        password
      );
      const requestBody: any = { reportPassword: encryptedPassword };
      const response = await ChannelkartNetworkPut(
        "/users/reportpassword",
        requestBody,
        headers
      );
      if (response?.status === 200) {
        setNeedPassword(false);
        setPasswordQuery(false)
        setPassword("");
        setConfirmPassword("");
        openPopup(
          "Success",
          "Your password has been changed successfully"
        );
      } else {
        console.error("Failed to change the report password. Response:", response);
        openPopup(
          "Error",
          "Failed to change the report password"
        );
        setPassword("");
        setConfirmPassword("");
      }
    } catch (error) {
      setPassword("");
      setConfirmPassword("");
      openPopup(
        "Error",
        "Failed to change the report password"
      );
      console.error(
        "An error occurred while changing the report password:",
        error
      );
    }
  };
  const [toggleState, setToggleState] = useState<boolean>(false);
  // const contactAddressInput = useRef<HTMLInputElement>(null);
  const [email, setEmail] = useState<string>(JSON.parse(localStorage.authContext).user.email);
  const sendOtp = async () => {
    setToggleState(!toggleState);
    const contactAddress: string = email;

    if(contactAddress.trim().length === 0){
      openPopup("Error", `Please enter valid email`);
      setToggleState(false);
      return;
    }
    const lob = getLob();
    if (contactAddress && lob) {
      try {
        localStorage.setItem("lob", lob);
        // const response = await sendForgotPasswordOtpAddress(
        //   contactAddress,
        //   "email"
        // );
        const response = await ChannelkartNetworkPost("/v1/otp/send/resource", {
          email: email,
          // countryCode: countryCode,
          resourceURL:"v1/otp/verify/resource"
        })
        
        if (response?.status === 200) {
          setSessionID(response?.data?.response?.sessionId)
          setVerifyOTPModal(true)
        } else {
          openPopup("Error", "Please retry after sometime");
        }
      } catch (error) {
        openPopup(
          "Error",
          `Email is not registered with us. Please contact support for assistance!`
        );
      }
    } else {
      openPopup(
        "Alert",
        contactAddress ? "Please Enter lob" : "Please Enter contact number"
      );
    }
    setToggleState(false);
  };

  const verifyOtp = async (otp:string) => {
    if (otp && otp.length === otpLength) {
      // setHeaderOtp(otp)
      // setVerifyOTPModal(false)
      // setValidateUserModal(false)
      // setChangePasswordModal(true);
      // return
      try {
        const response = await ChannelkartNetworkPost("/v1/otp/verify/resource", {
          otpString: otp,
          sessionID:sessionID,
          resourceURL:"/users/reportpassword"
        })
        if (response.data?.statusCode == 200) {
          setSessionIDVerify(response?.data?.sessionId)
          setVerifyOTPModal(false)
          setValidateUserModal(false)
          if(setPassFlow){
            setShowPasswordModal(true)
          }else{
            setChangePasswordModal(true);
          }
          return {result :true , message:'Success'};
        } else {
          return {result :false , message:"Please enter the correct OTP"};
        }
      } catch (error) {
        return {result :false , message:"Please enter the correct OTP"};
      }
    } else {
      return {result : false , message:"Enter complete OTP"};
    }
  };

  const onSuccess = ()=>{
    setisverifiedOtp(true);
  }

  const onFailure = (message:string)=>{
    setisverifiedOtp(false);
    openPopup("Error", message);
  }

  const resendOtp = async () => {
    try{
      const response = await ChannelkartNetworkPost("/v1/otp/send/resource", {
        email: email,
        // countryCode: countryCode,
        resourceURL:"v1/otp/verify/resource"
      })
      if (response?.status === 200) {
        setSessionID(response?.data?.response?.sessionId)
      }
  }catch(error:any){
    openPopup("Error", error.message  ?? "RESEND OTP ERROR");
    console.error(error);
  }
  };

  const dispatch = useDispatch();

  const fetchUiconfig = useCallback(async () => {
    const currentUserData = JSON.parse(localStorage.getItem("authContext") ?? "{}")?.user;
    const allConfig = await getAllConfiguartions();
    const clientConfig = allConfig.data.features.filter((config: { domainName: string; }) => config.domainName === "clientconfig");
    const uiConfig = allConfig.data.features.filter((config: { domainName: string; }) => config.domainName === "uiconfig");
    const uiConfigKey = clientConfig.find((config: { domainType: string }) => config.domainType === "config")?.domainValues?.[0]?.["uiConfigKey"];
    const roleBasedAccess = isRoleConfigEnabled(clientConfig);
    const isAdmin = currentUserData?.designation?.includes("admin");
    let finalReportList: reportListObject[] = [];

    if(isAdmin){
      const configName = "admin_report_configuration";
      let adminReportConfig = clientConfig.find((config: { domainType: string }) => config.domainType === configName);
      if(!adminReportConfig){
        finalReportList = getReportConfig("admin",uiConfigKey,uiConfig)
      }else{
        if(adminReportConfig?.domainValues){
          finalReportList = [...adminReportConfig.domainValues];
        }
      }
    }else{
      let mergedReportConfig: reportListObject[] = [];
      let roles = getUserRolesBasedOnAccess(roleBasedAccess,currentUserData);
      for(let role of roles){
        const configName = `${role}_report_configuration`;
        const roleReportConfig = clientConfig.find((config: { domainType: string }) => config.domainType === configName);
        if(roleReportConfig?.domainValues){
          mergedReportConfig = [...mergedReportConfig,...roleReportConfig.domainValues];
        }
      }
      finalReportList = Array.from(new Set(mergedReportConfig?.map((item) => item.id)))?.map((id) => {
        return mergedReportConfig.find((item) => item.id === id);
    }) as reportListObject[];
    if(finalReportList.length==0){
      for(let role of roles){
        const roleReportData = getReportConfig(role,uiConfigKey,uiConfig)
        if(roleReportData){
          mergedReportConfig = [...mergedReportConfig,...roleReportData];
        }
      }
      finalReportList = Array.from(new Set(mergedReportConfig?.map((item) => item.id))).map((id) => {
        return mergedReportConfig.find((item) => item.id === id);
      }) as reportListObject[];
    }
    }

    const fileFormatConfig = clientConfig.filter(
      (i: any) =>
        i.domainType === "config"
    );
    if(fileFormatConfig?.[0]?.domainValues?.[0]?.isDownloadReportCsv && fileFormatConfig[0].domainValues[0].isDownloadReportCsv == "true"){
      dispatch({type:"fileFormatAction",payload: { fileFormat: "csv" , config: fileFormatConfig?.[0]?.domainValues[0] } })
    }else{
      dispatch({type:"fileFormatAction",payload: { fileFormat: "xlsx" , config: fileFormatConfig?.[0]?.domainValues[0] } })
    }
    setReportList(finalReportList);
    return finalReportList;
  }, []);

  useEffect(() => {
    const method = async () => {
      await fetchUiconfig();
    };
    method();
    logEvent(eventEnum.live_dashboard,{feature_name:"Reports"})

  }, []);

  const types = Array.from(new Set(reportList?.map((item) => item.type)));
  const getReportUserInfo = async () => {
    try {
      const response = await ChannelkartNetworkGet("/users/reportpasswordinfo");
      const isPasswordSet = response?.data?.features[0]?.isPasswordSet;
      setPasswordConfig(isPasswordSet);
      const isEncryptionEnabled = response?.data?.features[0]?.isEncryptionEnabled;
      console.log("need")
      if(!isPasswordSet && isEncryptionEnabled){
        setNeedPassword(true)
      }
      if(isPasswordSet && isEncryptionEnabled){
        setHasPassword(true)
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  useEffect(() => {
    getReportUserInfo();
}, [])

  return (
    <div className="reports-main-container">
      {passwordQuery && <><Box
      sx={{
        display: "flex",
        alignItems: "center",
        padding: "8px 16px",
        backgroundColor: "#fff7e6",
        borderRadius: "8px",
        fontSize: "14px",
        width: "fit-content",
      }}
    >
      <InfoIcon
        sx={{
          color: "#f2a03b",
          marginRight: "8px",
          fontSize: "18px",
        }}
      />
      <Typography
        sx={{
          color: "#000",
          fontSize: "14px",
        }}
      >
        Your reports are encrypted for security.{" "}
        <Link
          onClick={()=>{
            // setShowPasswordModal(true)}
            setSetPassFlow(true)
            sendOtp()
          }
        }
          sx={{
            color: "#d49b44",
            textDecoration: "underline",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          Set a password
        </Link>{" "}
        to access them securely.
      </Typography>
    </Box></>}
    {hasPassword && <div style={{display:"flex",justifyContent:"end",marginTop:"10px",marginBottom:"-20px"}}>
        <Button
          onClick={() => {
            sendOtp()
            // setValidateUserModal(true)
            // setChangePasswordModal(true);
          }}
          variant="outlined"
          sx={{
            color: "#24c6b1",
            borderColor: "#24c6b1",
            width: "fit-content",
            "&:hover": {
              backgroundColor: "#e0f7f4",
            },
          }}
        >
          Change Password 
        </Button>
    </div>}
      {types.sort((a, b) => a.localeCompare(b)).map((type) => (
        <div key={type}>
          <h2 style={{ fontSize: '17px', color: '#237c9d', fontWeight: 600 }} className="report-heading">{translate(TranslationEnum.reports,`${type} Reports`)}</h2>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {reportList
              .filter((report: any) => report.type === type)
              .map((item) => (
                <ReportsTile
                needPassword={needPassword}
                setNeedPassword={setNeedPassword}
                setPasswordQuery={setPasswordQuery}
                  report={item}
                  key={item.id}
                  id={item.id}
                  name={item.name}
                  downloadCount={downloadCount}
                  type={item.type}
                  filter={item.filter}
                  parentFilter={item.parentFilter}
                  reportLoader={reportLoader}
                  setReportLoader={setReportLoader}
                  globalFilters={item.globalFilters}
                  batchDownload={item.batchDownload}
                  emailReportEnabled={item.emailReportEnabled}
                />
              ))}
          </Grid>
        </div>
      ))}
      {/* {reportLoader && <DownloadLoader
          message={"Your report will be downloaded shortly."}
          openReportModal={reportLoader}
          setOpenReportModal={setReportLoader}
      />} */}
      {
         downloads.length>0&&showDownload && <DownloadBar
        downloadCount={downloadCount}
        downloads={downloads}
        isPasswordSet={passwordConfig}
        />
      }
      {
        downloadCount>0&&(!showDownload)&&<DownloadBarIcon
        isPasswordSet={passwordConfig}
        
        />
      }
            <Modal
      centered
      withCloseButton={false}
      overlayOpacity={0.55}
      overlayBlur={3}
      opened={showPasswordModal}
      onClose={() => {setShowPasswordModal(false);setConfirmPassword("");setPassword("")}}
      radius="lg"
      size="420px"
      className="confirmationPopUp-modalContainer"
    >
      <div
        className="modal-content"
        style={{ display: "flex", flexDirection: "column",overflow:"auto" ,padding:"10px"}}
      >
        <div style={{ display: "flex",alignItems:"center"}}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // marginRight: "10px",
            width: "38px",
            height: "38px",
            borderRadius: "50%",
            // backgroundColor: "#1c7ea0",
            padding: "5px",
          }}
        >
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 57 57" fill="none">
              <g clip-path="url(#clip0_1546_28067)">
                <path d="M30.6827 54.5314H8.98879C8.52182 54.5314 8.05941 54.4395 7.62798 54.2608C7.19655 54.0821 6.80454 53.8201 6.47434 53.4899C6.14414 53.1597 5.88221 52.7677 5.70351 52.3363C5.52481 51.9049 5.43285 51.4425 5.43286 50.9755V3.55593C5.43286 2.61284 5.8075 1.70837 6.47437 1.04151C7.14124 0.374642 8.0457 0 8.98879 0L26.1388 0C27.0819 -5.62172e-06 27.9863 0.374622 28.6532 1.04147L42.1312 14.5195C42.7981 15.1864 43.1727 16.0909 43.1728 17.034V54.1945L30.6827 54.5314Z" fill="#F0D5A9" />
                <path d="M12.0811 21.2709H36.5244" stroke="#D6AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.0811 26.098H36.5244" stroke="#D6AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.0811 30.9249H24.3027" stroke="#D6AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M27.6116 0.319519C27.9997 0.49552 28.3527 0.740305 28.6536 1.04204L42.131 14.5194C42.4327 14.8203 42.6775 15.1734 42.8535 15.5615H31.0126C30.1107 15.5614 29.2456 15.203 28.6078 14.5652C27.97 13.9274 27.6117 13.0624 27.6116 12.1604V0.319519Z" fill="#E2BE8A" />
                <circle cx="43" cy="47" r="11" fill="white" />
                <path d="M40.4999 42.8333C40.4999 42.1703 40.7633 41.5344 41.2322 41.0656C41.701 40.5967 42.3369 40.3333 42.9999 40.3333C43.663 40.3333 44.2988 40.5967 44.7677 41.0656C45.2365 41.5344 45.4999 42.1703 45.4999 42.8333V44.5H47.1666V42.8333C47.1666 41.7283 46.7276 40.6685 45.9462 39.8871C45.1648 39.1057 44.105 38.6667 42.9999 38.6667C41.8948 38.6667 40.835 39.1057 40.0536 39.8871C39.2722 40.6685 38.8333 41.7283 38.8333 42.8333V44.5H40.4999V42.8333Z" fill="#BCBEC0" />
                <path d="M47.1666 44.5H38.8333C38.1702 44.5 37.5343 44.7634 37.0655 45.2322C36.5966 45.7011 36.3333 46.337 36.3333 47V52.8333C36.3333 53.4964 36.5966 54.1323 37.0655 54.6011C37.5343 55.0699 38.1702 55.3333 38.8333 55.3333H47.1666C47.8296 55.3333 48.4655 55.0699 48.9344 54.6011C49.4032 54.1323 49.6666 53.4964 49.6666 52.8333V47C49.6666 46.337 49.4032 45.7011 48.9344 45.2322C48.4655 44.7634 47.8296 44.5 47.1666 44.5ZM43.8333 51.1667C43.8333 51.3877 43.7455 51.5996 43.5892 51.7559C43.4329 51.9122 43.2209 52 42.9999 52C42.7789 52 42.5669 51.9122 42.4107 51.7559C42.2544 51.5996 42.1666 51.3877 42.1666 51.1667V48.6667C42.1666 48.4457 42.2544 48.2337 42.4107 48.0774C42.5669 47.9211 42.7789 47.8333 42.9999 47.8333C43.2209 47.8333 43.4329 47.9211 43.5892 48.0774C43.7455 48.2337 43.8333 48.4457 43.8333 48.6667V51.1667Z" fill="#FFAC33" />
              </g>
              <defs>
                <clipPath id="clip0_1546_28067">
                  <rect width="57" height="57" fill="white" />
                </clipPath>
              </defs>
            </svg>
        </div>
        <p
          style={{
            color: "#909090",
            fontSize: "16px",
            marginBottom:"0"
          }}
        >
          Create a password for reports
        </p>
        </div>
        <TextField
          sx={{
            width: "100%",
            marginTop:"10px"
          }}
          size="small"
          placeholder="Enter Password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          label="Password"
          type={showPassword ? "text" : "password"}
          InputProps={{
            endAdornment: (
              <IconButton
                onClick={() => setShowPassword((prev) => !prev)}
                edge="end"
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            ),
          }}
        />
        <div style={{ width: "100%", marginTop: "1rem" }}>
          <ul style={{ listStyle: "none", padding: 0 }}>
            <li style={{ color: validations.length ? "green" : "red" }}>
              {validations.length ? "✔" : "✖"} Must be 8-20 Characters
            </li>
            <li style={{ color: validations.uppercase ? "green" : "red" }}>
              {validations.uppercase ? "✔" : "✖"} Include Uppercase Letters (A-Z)
            </li>
            <li style={{ color: validations.lowercase ? "green" : "red" }}>
              {validations.lowercase ? "✔" : "✖"} Include Lowercase Letters (a-z)
            </li>
            <li style={{ color: validations.number ? "green" : "red" }}>
              {validations.number ? "✔" : "✖"} Include Numbers (0-9)
            </li>
            <li style={{ color: validations.symbol ? "green" : "red" }}>
              {validations.symbol ? "✔" : "✖"} Include Symbols (@$!%*?&)
            </li>
          </ul>
        </div>
        <TextField
          sx={{
            width: "100%",
          }}
          size="small"
          placeholder="Re-enter Password"
          value={confirmPassword}
          onChange={(event) => setConfirmPassword(event.target.value)}
          label="Re-enter Password"
          error={!passwordsMatch && confirmPassword !== ""}
          type={showConfirmPassword ? "text" : "password"}
          InputProps={{
            endAdornment: (
              <IconButton
                onClick={() => setShowConfirmPassword((prev) => !prev)}
                edge="end"
              >
                {showConfirmPassword ?<Visibility /> : <VisibilityOff />}
              </IconButton>
            ),
          }}
        />
        {confirmPassword && !passwordsMatch && (
          <p style={{ color: "red", marginTop: "0.5rem" }}>
            Passwords do not match
          </p>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "1rem",
          }}
        >
          <Button
             onClick={() => {
              setShowPasswordModal(false);
              setReportPassword();
            }}
            disabled={!allValid || !passwordsMatch}
            variant="contained"
            color="primary"
            style={{
              width: "100%",
              backgroundColor: allValid && passwordsMatch ? "#24c6b1" : "#ccc",
            }}
          >
            Set Password
          </Button>
        </div>
      </div>
    </Modal>
    <Modal
      centered
      withCloseButton={false}
      overlayOpacity={0.55}
      overlayBlur={3}
      opened={changePasswordModal}
      onClose={() => {setChangePasswordModal(false); setConfirmPassword("");setPassword("")}}
      radius="lg"
      size="420px"
      className="confirmationPopUp-modalContainer"
    >
      <div
        className="modal-content"
        style={{ display: "flex", flexDirection: "column",overflow:"auto",padding:"10px" }}
      >
         <div style={{ display: "flex",alignItems:"center"}}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // marginRight: "10px",
            width: "38px",
            height: "38px",
            borderRadius: "50%",
            // backgroundColor: "#1c7ea0",
            padding: "5px",
          }}
        >
           <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 57 57" fill="none">
              <g clip-path="url(#clip0_1546_28067)">
                <path d="M30.6827 54.5314H8.98879C8.52182 54.5314 8.05941 54.4395 7.62798 54.2608C7.19655 54.0821 6.80454 53.8201 6.47434 53.4899C6.14414 53.1597 5.88221 52.7677 5.70351 52.3363C5.52481 51.9049 5.43285 51.4425 5.43286 50.9755V3.55593C5.43286 2.61284 5.8075 1.70837 6.47437 1.04151C7.14124 0.374642 8.0457 0 8.98879 0L26.1388 0C27.0819 -5.62172e-06 27.9863 0.374622 28.6532 1.04147L42.1312 14.5195C42.7981 15.1864 43.1727 16.0909 43.1728 17.034V54.1945L30.6827 54.5314Z" fill="#F0D5A9" />
                <path d="M12.0811 21.2709H36.5244" stroke="#D6AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.0811 26.098H36.5244" stroke="#D6AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.0811 30.9249H24.3027" stroke="#D6AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M27.6116 0.319519C27.9997 0.49552 28.3527 0.740305 28.6536 1.04204L42.131 14.5194C42.4327 14.8203 42.6775 15.1734 42.8535 15.5615H31.0126C30.1107 15.5614 29.2456 15.203 28.6078 14.5652C27.97 13.9274 27.6117 13.0624 27.6116 12.1604V0.319519Z" fill="#E2BE8A" />
                <circle cx="43" cy="47" r="11" fill="white" />
                <path d="M40.4999 42.8333C40.4999 42.1703 40.7633 41.5344 41.2322 41.0656C41.701 40.5967 42.3369 40.3333 42.9999 40.3333C43.663 40.3333 44.2988 40.5967 44.7677 41.0656C45.2365 41.5344 45.4999 42.1703 45.4999 42.8333V44.5H47.1666V42.8333C47.1666 41.7283 46.7276 40.6685 45.9462 39.8871C45.1648 39.1057 44.105 38.6667 42.9999 38.6667C41.8948 38.6667 40.835 39.1057 40.0536 39.8871C39.2722 40.6685 38.8333 41.7283 38.8333 42.8333V44.5H40.4999V42.8333Z" fill="#BCBEC0" />
                <path d="M47.1666 44.5H38.8333C38.1702 44.5 37.5343 44.7634 37.0655 45.2322C36.5966 45.7011 36.3333 46.337 36.3333 47V52.8333C36.3333 53.4964 36.5966 54.1323 37.0655 54.6011C37.5343 55.0699 38.1702 55.3333 38.8333 55.3333H47.1666C47.8296 55.3333 48.4655 55.0699 48.9344 54.6011C49.4032 54.1323 49.6666 53.4964 49.6666 52.8333V47C49.6666 46.337 49.4032 45.7011 48.9344 45.2322C48.4655 44.7634 47.8296 44.5 47.1666 44.5ZM43.8333 51.1667C43.8333 51.3877 43.7455 51.5996 43.5892 51.7559C43.4329 51.9122 43.2209 52 42.9999 52C42.7789 52 42.5669 51.9122 42.4107 51.7559C42.2544 51.5996 42.1666 51.3877 42.1666 51.1667V48.6667C42.1666 48.4457 42.2544 48.2337 42.4107 48.0774C42.5669 47.9211 42.7789 47.8333 42.9999 47.8333C43.2209 47.8333 43.4329 47.9211 43.5892 48.0774C43.7455 48.2337 43.8333 48.4457 43.8333 48.6667V51.1667Z" fill="#FFAC33" />
              </g>
              <defs>
                <clipPath id="clip0_1546_28067">
                  <rect width="57" height="57" fill="white" />
                </clipPath>
              </defs>
            </svg>
        </div>
        <p
          style={{
            color: "#909090",
            fontSize: "16px",
            marginBottom: "0",
          }}
        >
           Change password for reports
        </p>
        </div>
        <TextField
          sx={{
            width: "100%",
            marginTop:"10px"
          }}
          size="small"
          placeholder="Enter Password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          label="Password"
          type={showPassword ? "text" : "password"}
          InputProps={{
            endAdornment: (
              <IconButton
                onClick={() => setShowPassword((prev) => !prev)}
                edge="end"
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            ),
          }}
        />
        <div style={{ width: "100%", marginTop: "1rem" }}>
          <ul style={{ listStyle: "none", padding: 0 }}>
            <li style={{ color: validations.length ? "green" : "red" }}>
              {validations.length ? "✔" : "✖"} Must be 8-20 Characters
            </li>
            <li style={{ color: validations.uppercase ? "green" : "red" }}>
              {validations.uppercase ? "✔" : "✖"} Include Uppercase Letters (A-Z)
            </li>
            <li style={{ color: validations.lowercase ? "green" : "red" }}>
              {validations.lowercase ? "✔" : "✖"} Include Lowercase Letters (a-z)
            </li>
            <li style={{ color: validations.number ? "green" : "red" }}>
              {validations.number ? "✔" : "✖"} Include Numbers (0-9)
            </li>
            <li style={{ color: validations.symbol ? "green" : "red" }}>
              {validations.symbol ? "✔" : "✖"} Include Symbols (@$!%*?&)
            </li>
          </ul>
        </div>
        <TextField
          sx={{
            width: "100%",
          }}
          size="small"
          placeholder="Re-enter Password"
          value={confirmPassword}
          onChange={(event) => setConfirmPassword(event.target.value)}
          label="Re-enter Password"
          error={!passwordsMatch && confirmPassword !== ""}
          type={showConfirmPassword ? "text" : "password"}
          InputProps={{
            endAdornment: (
              <IconButton
                onClick={() => setShowConfirmPassword((prev) => !prev)}
                edge="end"
              >
                {showConfirmPassword ?<Visibility /> : <VisibilityOff />}
              </IconButton>
            ),
          }}
        />
        {confirmPassword && !passwordsMatch && (
          <p style={{ color: "red", marginTop: "0.5rem" }}>
            Passwords do not match
          </p>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "1rem",
          }}
        >
          <Button
             onClick={() => {
              setChangePasswordModal(false);
              changeReportPassword();
            }}
            disabled={!allValid || !passwordsMatch}
            variant="contained"
            color="primary"
            style={{
              width: "100%",
              backgroundColor: allValid && passwordsMatch ? "#24c6b1" : "#ccc",
            }}
          >
            Change Password
          </Button>
        </div>
      </div>
    </Modal>
    <Modal
      centered
      withCloseButton={false}
      overlayOpacity={0.55}
      overlayBlur={3}
      opened={validateUserModal}
      onClose={() => {setValidateUserModal(false); setConfirmPassword("");setPassword("")}}
      radius="lg"
      size="420px"
      className="confirmationPopUp-modalContainer"
    >
      <div
        className="modal-content"
        style={{ display: "flex", flexDirection: "column",overflow:"auto",padding:"10px" }}
      >
         <div style={{ display: "flex",alignItems:"center"}}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // marginRight: "10px",
            width: "38px",
            height: "38px",
            borderRadius: "50%",
            // backgroundColor: "#1c7ea0",
            padding: "5px",
          }}
        >
           <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 57 57" fill="none">
              <g clip-path="url(#clip0_1546_28067)">
                <path d="M30.6827 54.5314H8.98879C8.52182 54.5314 8.05941 54.4395 7.62798 54.2608C7.19655 54.0821 6.80454 53.8201 6.47434 53.4899C6.14414 53.1597 5.88221 52.7677 5.70351 52.3363C5.52481 51.9049 5.43285 51.4425 5.43286 50.9755V3.55593C5.43286 2.61284 5.8075 1.70837 6.47437 1.04151C7.14124 0.374642 8.0457 0 8.98879 0L26.1388 0C27.0819 -5.62172e-06 27.9863 0.374622 28.6532 1.04147L42.1312 14.5195C42.7981 15.1864 43.1727 16.0909 43.1728 17.034V54.1945L30.6827 54.5314Z" fill="#F0D5A9" />
                <path d="M12.0811 21.2709H36.5244" stroke="#D6AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.0811 26.098H36.5244" stroke="#D6AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.0811 30.9249H24.3027" stroke="#D6AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M27.6116 0.319519C27.9997 0.49552 28.3527 0.740305 28.6536 1.04204L42.131 14.5194C42.4327 14.8203 42.6775 15.1734 42.8535 15.5615H31.0126C30.1107 15.5614 29.2456 15.203 28.6078 14.5652C27.97 13.9274 27.6117 13.0624 27.6116 12.1604V0.319519Z" fill="#E2BE8A" />
                <circle cx="43" cy="47" r="11" fill="white" />
                <path d="M40.4999 42.8333C40.4999 42.1703 40.7633 41.5344 41.2322 41.0656C41.701 40.5967 42.3369 40.3333 42.9999 40.3333C43.663 40.3333 44.2988 40.5967 44.7677 41.0656C45.2365 41.5344 45.4999 42.1703 45.4999 42.8333V44.5H47.1666V42.8333C47.1666 41.7283 46.7276 40.6685 45.9462 39.8871C45.1648 39.1057 44.105 38.6667 42.9999 38.6667C41.8948 38.6667 40.835 39.1057 40.0536 39.8871C39.2722 40.6685 38.8333 41.7283 38.8333 42.8333V44.5H40.4999V42.8333Z" fill="#BCBEC0" />
                <path d="M47.1666 44.5H38.8333C38.1702 44.5 37.5343 44.7634 37.0655 45.2322C36.5966 45.7011 36.3333 46.337 36.3333 47V52.8333C36.3333 53.4964 36.5966 54.1323 37.0655 54.6011C37.5343 55.0699 38.1702 55.3333 38.8333 55.3333H47.1666C47.8296 55.3333 48.4655 55.0699 48.9344 54.6011C49.4032 54.1323 49.6666 53.4964 49.6666 52.8333V47C49.6666 46.337 49.4032 45.7011 48.9344 45.2322C48.4655 44.7634 47.8296 44.5 47.1666 44.5ZM43.8333 51.1667C43.8333 51.3877 43.7455 51.5996 43.5892 51.7559C43.4329 51.9122 43.2209 52 42.9999 52C42.7789 52 42.5669 51.9122 42.4107 51.7559C42.2544 51.5996 42.1666 51.3877 42.1666 51.1667V48.6667C42.1666 48.4457 42.2544 48.2337 42.4107 48.0774C42.5669 47.9211 42.7789 47.8333 42.9999 47.8333C43.2209 47.8333 43.4329 47.9211 43.5892 48.0774C43.7455 48.2337 43.8333 48.4457 43.8333 48.6667V51.1667Z" fill="#FFAC33" />
              </g>
              <defs>
                <clipPath id="clip0_1546_28067">
                  <rect width="57" height="57" fill="white" />
                </clipPath>
              </defs>
            </svg>
        </div>
        <p
          style={{
            color: "#909090",
            fontSize: "16px",
            marginBottom: "0",
          }}
        >
           Change password for reports
        </p>
        </div>
        <form className="loginInputs">
            <TextInput
              sx={{ width: "70%", marginTop: "5%", borderRadius: "7rem" }}
              id="contactNumber"
              placeholder={
                translate(TranslationEnum.login_and_change_password,"Enter Email Address")
              }
              type={"email"}
              // ref={contactAddressInput}
            />
            <ToogleButton
              status1="SEND OTP"
              status2="SENDING"
              handleChange={sendOtp}
              updateToggleState={toggleState}
              className="login-toggle-unchecked-icon-status-translation"
            />
          </form>
      </div>
    </Modal>
    <Modal
      centered
      withCloseButton={false}
      overlayOpacity={0.55}
      overlayBlur={3}
      opened={verifyOTPModal}
      onClose={() => {setVerifyOTPModal(false); setConfirmPassword("");setPassword("")}}
      radius="lg"
      size="420px"
      className="confirmationPopUp-modalContainer"
    >
      <div
        className="modal-content"
        style={{ display: "flex", flexDirection: "column",overflow:"auto"}}
      >
         <div style={{ display: "flex",alignItems:"center"}}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // marginRight: "10px",
            width: "38px",
            height: "38px",
            borderRadius: "50%",
            // backgroundColor: "#1c7ea0",
            padding: "5px",
          }}
        >
           <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 57 57" fill="none">
              <g clip-path="url(#clip0_1546_28067)">
                <path d="M30.6827 54.5314H8.98879C8.52182 54.5314 8.05941 54.4395 7.62798 54.2608C7.19655 54.0821 6.80454 53.8201 6.47434 53.4899C6.14414 53.1597 5.88221 52.7677 5.70351 52.3363C5.52481 51.9049 5.43285 51.4425 5.43286 50.9755V3.55593C5.43286 2.61284 5.8075 1.70837 6.47437 1.04151C7.14124 0.374642 8.0457 0 8.98879 0L26.1388 0C27.0819 -5.62172e-06 27.9863 0.374622 28.6532 1.04147L42.1312 14.5195C42.7981 15.1864 43.1727 16.0909 43.1728 17.034V54.1945L30.6827 54.5314Z" fill="#F0D5A9" />
                <path d="M12.0811 21.2709H36.5244" stroke="#D6AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.0811 26.098H36.5244" stroke="#D6AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.0811 30.9249H24.3027" stroke="#D6AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M27.6116 0.319519C27.9997 0.49552 28.3527 0.740305 28.6536 1.04204L42.131 14.5194C42.4327 14.8203 42.6775 15.1734 42.8535 15.5615H31.0126C30.1107 15.5614 29.2456 15.203 28.6078 14.5652C27.97 13.9274 27.6117 13.0624 27.6116 12.1604V0.319519Z" fill="#E2BE8A" />
                <circle cx="43" cy="47" r="11" fill="white" />
                <path d="M40.4999 42.8333C40.4999 42.1703 40.7633 41.5344 41.2322 41.0656C41.701 40.5967 42.3369 40.3333 42.9999 40.3333C43.663 40.3333 44.2988 40.5967 44.7677 41.0656C45.2365 41.5344 45.4999 42.1703 45.4999 42.8333V44.5H47.1666V42.8333C47.1666 41.7283 46.7276 40.6685 45.9462 39.8871C45.1648 39.1057 44.105 38.6667 42.9999 38.6667C41.8948 38.6667 40.835 39.1057 40.0536 39.8871C39.2722 40.6685 38.8333 41.7283 38.8333 42.8333V44.5H40.4999V42.8333Z" fill="#BCBEC0" />
                <path d="M47.1666 44.5H38.8333C38.1702 44.5 37.5343 44.7634 37.0655 45.2322C36.5966 45.7011 36.3333 46.337 36.3333 47V52.8333C36.3333 53.4964 36.5966 54.1323 37.0655 54.6011C37.5343 55.0699 38.1702 55.3333 38.8333 55.3333H47.1666C47.8296 55.3333 48.4655 55.0699 48.9344 54.6011C49.4032 54.1323 49.6666 53.4964 49.6666 52.8333V47C49.6666 46.337 49.4032 45.7011 48.9344 45.2322C48.4655 44.7634 47.8296 44.5 47.1666 44.5ZM43.8333 51.1667C43.8333 51.3877 43.7455 51.5996 43.5892 51.7559C43.4329 51.9122 43.2209 52 42.9999 52C42.7789 52 42.5669 51.9122 42.4107 51.7559C42.2544 51.5996 42.1666 51.3877 42.1666 51.1667V48.6667C42.1666 48.4457 42.2544 48.2337 42.4107 48.0774C42.5669 47.9211 42.7789 47.8333 42.9999 47.8333C43.2209 47.8333 43.4329 47.9211 43.5892 48.0774C43.7455 48.2337 43.8333 48.4457 43.8333 48.6667V51.1667Z" fill="#FFAC33" />
              </g>
              <defs>
                <clipPath id="clip0_1546_28067">
                  <rect width="57" height="57" fill="white" />
                </clipPath>
              </defs>
            </svg>
        </div>
        <p
          style={{
            color: "#909090",
            fontSize: "16px",
            marginBottom: "0",
          }}
        >
           Verify your identity
        </p>
        </div>
        <ReportOtp
            OtpVerficationHeader={
              <div className="otp-label" style={{color:"black",fontWeight:500,paddingBlock:"20px"}}>
                 {translate(TranslationEnum.validate_otp,"OTP sent to your registered {phoneNumber}",{"phoneNumber":contactAddressType === "sms" ? "Phone Number" : "Email ID"})} &nbsp;
                {
                email && maskEmail(email)
                }
              </div>
            }
            onFailure={onFailure}
            onSuccess={onSuccess}
            resendOtp={resendOtp}
            verifyOTP={verifyOtp}
            otpLength={otpLength}
          />
      </div>
    </Modal> 
    </div>
  );
};

export default Reports;
 